import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'bi bi-speedometer2',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/alert',
    title: 'Operation Data',
    icon: 'bi bi-bell',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/badges',
    title: 'Event Logs',
    icon: 'bi bi-patch-check',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/buttons',
    title: 'Conductivity Profiles',
    icon: 'bi bi-hdd-stack',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/component/m',
        title: 'Manage',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [],
     },
	 {
        path: '/component/a',
        title: 'Add',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [],
      },
	  {
        path: '/component/i',
        title: 'Import',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [],
      },
	  {
        path: '/component/v',
        title: 'View',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [],
      }
    ],
  },
  {
    path: '/component/card',
    title: 'Graphs',
    icon: 'bi bi-card-text',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/dropdown',
    title: 'Projects',
    icon: 'bi bi-menu-app',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/pagination',
    title: 'Admin',
    icon: 'bi bi-dice-1',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/component/pagination',
        title: 'Companies',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [
          {
            path: '/component/companies',
            title: 'Manage',
            icon: 'bi bi-people',
            class: '',
            extralink: false,
            submenu: [],
          },
          {
            path: '/component/company-add',
            title: 'Add',
            icon: 'bi bi-people',
            class: '',
            extralink: false,
            submenu: [],
          },
        ],
      },
      {
        path: '/component/models',
        title: 'Models',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [
          {
            path: '/component/models',
            title: 'Manage',
            icon: 'bi bi-people',
            class: '',
            extralink: false,
            submenu: [],
          },
          {
            path: '/component/model-add',
            title: 'Add',
            icon: 'bi bi-people',
            class: '',
            extralink: false,
            submenu: [],
          }
        ],
      },
      {
        path: '/component/pagination',
        title: 'User',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [
          {
            path: '/component/user',
            title: 'Manage',
            icon: 'bi bi-people',
            class: '',
            extralink: false,
            submenu: [],
          },
          {
            path: '/component/user-add',
            title: 'Add',
            icon: 'bi bi-people',
            class: '',
            extralink: false,
            submenu: [],
          },
        ],
      },
      {
        path: '/component/pagination',
        title: 'Manufacturer',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [
          {
            path: '/component/manufacturers',
            title: 'Manage',
            icon: 'bi bi-people',
            class: '',
            extralink: false,
            submenu: [],
          },
          {
            path: '/component/manuf-add',
            title: 'Add',
            icon: 'bi bi-people',
            class: '',
            extralink: false,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    path: '/component/nav',
    title: 'Resources',
    icon: 'bi bi-pause-btn',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/table',
    title: 'Restore',
    icon: 'bi bi-layout-split',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/about',
    title: 'Help',
    icon: 'bi bi-people',
    class: '',
    extralink: false,
    submenu: [],
  },
];

export const NonAdminRoutes: RouteInfo[] = [
  
  {
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'bi bi-speedometer2',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/alert',
    title: 'Operation Data',
    icon: 'bi bi-bell',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/badges',
    title: 'Event Logs',
    icon: 'bi bi-patch-check',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/buttons',
    title: 'Conductivity Profiles',
    icon: 'bi bi-hdd-stack',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/component/m',
        title: 'Manage',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [],
     },
	 {
        path: '/component/a',
        title: 'Add',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [],
      },
	  {
        path: '/component/i',
        title: 'Import',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [],
      },
	  {
        path: '/component/v',
        title: 'View',
        icon: 'bi bi-people',
        class: '',
        extralink: false,
        submenu: [],
      }
    ],
  },
  {
    path: '/component/card',
    title: 'Graphs',
    icon: 'bi bi-card-text',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/dropdown',
    title: 'Projects',
    icon: 'bi bi-menu-app',
    class: '',
    extralink: false,
    submenu: [],
  },
  
  {
    path: '/component/nav',
    title: 'Resources',
    icon: 'bi bi-pause-btn',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/component/table',
    title: 'Restore',
    icon: 'bi bi-layout-split',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/about',
    title: 'Help',
    icon: 'bi bi-people',
    class: '',
    extralink: false,
    submenu: [],
  },
];